<div class="container">
  <ng-container [formGroup]="model">
    <mat-form-field libZalamoField>
      <mat-label translate>clhqjh0xp000008mg3v55fbh8</mat-label>
      <input matInput formControlName="name" (keydown.enter)="submit()" />
      @if (model.controls.name.touched && model.controls.name.errors) {
        <mat-error translate>clhqjh67w000108mg2qeaa52j </mat-error>
      }
      <lib-zalamo-field-decoration></lib-zalamo-field-decoration
    ></mat-form-field>
  </ng-container>
  <div class="button">
    <lib-button lg (click)="submit()" forceContext="common" translate
      >save</lib-button
    >
    <lib-button lg (click)="skip()" forceContext="common" translate
      >skip</lib-button
    >
  </div>
</div>
